import { Injectable } from '@angular/core';

@Injectable()
export class BaseCustomerOnboardingService {
  loadScript() {
    let isFound = false;
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; ++i) {
      if (
        scripts[i].getAttribute('src') != null &&
        scripts[i].getAttribute('src')?.includes('meetings-eu1.hubspot.com')
      ) {
        isFound = true;
      }
    }

    if (!isFound) {
      let node = document.createElement('script');
      node.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
      node.type = 'text/javascript';
      node.async = false;
      document.getElementsByTagName('body')[0].appendChild(node);
    }
  }
}
